/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{substitute as s}from"./string.js";class t{constructor(t,e,i){this.name=t,this.details=i,this.type="warning",this.message=e?s(e,i):""}toString(){const{name:s,message:t}=this;return`[${s}]: ${t}`}}export{t as default};
